import { tr } from 'mmfintech-commons'
import styles from './CoreStatusView.module.scss'

type CoreStatusViewProps = {
  status: string
  label?: string
  fade?: boolean
  size?: 'small' | 'medium'
  hideText?: boolean
}

export const CoreStatusView = ({ status, label, fade, size = 'small', hideText = false }: CoreStatusViewProps) => {
  const opacityValue = fade ? 0.5 : 1
  const parsedStatus = status.toLocaleLowerCase()

  return (
    <div className={styles['status-view']}>
      <span className={parsedStatus} data-test='core-status-initial-circle'></span>
      {!hideText && (
        <p className={size} data-test='core-status-initial-text' style={{ opacity: opacityValue }}>
          {label ??
            tr(`METADATA.TRANSACTION_STATUS.${status.toUpperCase()}`, status.replace(/_/g, ' ').toLocaleLowerCase())}
        </p>
      )}
    </div>
  )
}
